module.exports = __webpack_public_path__ + "media/images/icons/flags/SN-00dd4e26a7ffde9b92fdfa803ba5daa7.svg";